import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { sistemaActions } from "../sistema/recucer";

function useIsMobile() {
  const dispatch = useDispatch();
  const largura = window.innerWidth;

  useEffect(() => {
    function handleResize() {
      dispatch(sistemaActions.setaIsMobile(largura <= 768))
    }

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, largura]);
}

export default useIsMobile;